module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.4-245.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.4.md
// module id = 689
// module chunks = 276